import { render, staticRenderFns } from "./addOrDebitScore.vue?vue&type=template&id=44498755&scoped=true&"
import script from "./addOrDebitScore.vue?vue&type=script&lang=js&"
export * from "./addOrDebitScore.vue?vue&type=script&lang=js&"
import style0 from "./addOrDebitScore.vue?vue&type=style&index=0&id=44498755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44498755",
  null
  
)

export default component.exports